import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b0bc99f")

_pushScopeId("data-v-0b0bc99f")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 建议添加 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { style: {"margin-left":"160px"} }, "次/ 天", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 企业申请转移功能的使用截止日期 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 在系统中功能使用的期限 ")
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.visible = $event)),
    width: "1000px",
    "before-close": _ctx.onCancel
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.formData,
        "label-width": "auto"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "单位名称:",
            prop: "orgName"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.orgName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.orgName = $event)),
                maxlength: "24"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "单位证书编码:",
            prop: "code"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.code = $event)),
                maxlength: "24"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "系统代码:",
            prop: "systemCode"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.systemCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.systemCode = $event)),
                maxlength: "24"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "密码字符串:",
            prop: "password"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.password,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.password = $event)),
                maxlength: "128"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Key私钥:",
            prop: "secretKey"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.secretKey,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.secretKey = $event)),
                style: {"width":"500px"},
                rows: 10,
                type: "textarea",
                maxlength: "2500",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "所属交管平台:",
            prop: "gab122Name"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.gab122Name,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.gab122Name = $event)),
                placeholder: "请选择",
                filterable: "",
                clearable: ""
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "API调用次数:",
            prop: "apiDayCnt"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                style: {"width":"50px"},
                modelValue: _ctx.formData.apiDayCnt,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.apiDayCnt = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "申请的截止日期:",
            prop: "applyEndTime"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.applyEndTime,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.applyEndTime = $event)),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD",
                type: "date",
                "disabled-date": _ctx.disabledDate,
                style: {"width":"200px"}
              }, null, 8, ["modelValue", "disabled-date"]),
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider),
          _createVNode(_component_el_form_item, {
            label: "系统功能截止日期:",
            prop: "systemUseEndTime"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.systemUseEndTime,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.systemUseEndTime = $event)),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD",
                type: "date",
                "disabled-date": _ctx.disabledDate,
                style: {"width":"200px"}
              }, null, 8, ["modelValue", "disabled-date"]),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})